import { render } from "./UseCasesSection.vue?vue&type=template&id=464d8192&scoped=true"
import script from "./UseCasesSection.vue?vue&type=script&lang=js"
export * from "./UseCasesSection.vue?vue&type=script&lang=js"

import "./UseCasesSection.vue?vue&type=style&index=0&id=464d8192&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464d8192"]])

export default __exports__